module.exports = __webpack_public_path__ + "img/zhu1.93b97b72.png";